
import { Options, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import { SearchContents, SearchContentTypesEnum, SearchMode, SearchResult } from '@rtl/api'

import { SEARCH_ACTION, SEARCH_NAMESPACE, SearchPayload } from '../../store'
import CelebrityCardList from '../components/celebrity/CelebrityCardList.vue'
import Search from '../components/icons/Search.vue'
import ContentListPage from '../pages/ContentListPage.vue'
import { WidgetMeta } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'Celeb listaoldal',
  groups: {
    style: 'Beállítás',
    data: 'Adatok'
  },
  defaultGroup: 'style',
  fields: {
    title: {
      label: 'Címsor',
      type: String,
      default: ''
    },
    showFilters: {
      type: Boolean,
      default: true,
      props: {
        label: 'Szűrők megjelenítése'
      }
    },
    payload: {
      group: 'data',
      type: 'payload',
      default: {}
    }
  }
}

@Options({
  name: 'CelebrityPageWidget',
  components: {
    CelebrityCardList,
    ContentListPage,
    Search
  }
})
export default class CelebrityPageWidget extends Vue {
  @Action(SEARCH_ACTION.SEARCH, { namespace: SEARCH_NAMESPACE })
  searchAction!: (payload: SearchPayload) => Promise<SearchResult>

  searchText = ''
  searchLoading = false
  searchResults: SearchContents | null = null

  async searchByInput () {
    if (this.searchText) {
      this.searchLoading = true
      const result = await this.searchAction({
        searchText: this.searchText,
        contentTypes: [SearchContentTypesEnum.Celeb, SearchContentTypesEnum.Character],
        searchMode: SearchMode.Global,
        offset: 0,
        limit: 6
      })
      this.searchLoading = false
      this.searchResults = result.data.celeb ?? null
    } else {
      this.searchResults = null
    }
  }
}
